import { render, staticRenderFns } from "./ReceitaDigital.vue?vue&type=template&id=5880c838"
import script from "./ReceitaDigital.vue?vue&type=script&lang=js"
export * from "./ReceitaDigital.vue?vue&type=script&lang=js"
import style0 from "./ReceitaDigital.vue?vue&type=style&index=0&id=5880c838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports